import React, {useState, useRef} from 'react'
import "./MapSection.css"
import mapBackground from "../../assets/images/map-footer-bg.svg"
import mapBackgroundSmall from "../../assets/images/map-small-screen.svg"
import replyIcon from '../../assets/images/reply-icon.svg'
import postsImageOne from '../../assets/images/default-avatar-2022dx.jpg'
// import postsImageTwo from '../../assets/images/default-avatar-2020-30.jpeg'
// import ReactGA from 'react-ga4'
// import { useInView } from 'framer-motion'


const MapSection = () => {

    const [isHidden, setIsHidden] = useState(true)

    const mapRef = useRef(null)
    // const mapIsInView = useInView(mapRef, { once: false}, { margin: "50% 0px 50% 0px" });

    const showCard = () => {
        setIsHidden(false)
    }

    const hideCard = () => {
        setIsHidden(true)
    }


  return (
    <>
 {/* Desktop View */}
<div className='uk-section uk-padding-remove trip-background-moss uk-visible@s' >
        <div data-src={mapBackground} uk-img={mapBackground} className=" uk-background-norepeat uk-background-cover uk-background-top-left uk-section uk-flex" >    
        <div className="uk-width-1-1 uk-flex">


                <div className="uk-container uk-container-large uk-padding"> 

                <div ref={mapRef} className="rehere" >

                </div>

                    <div className="uk-grid-collapse uk-grid-margin uk-grid uk-grid-large" uk-grid="">


                        <div className="uk-grid-item-match uk-width-2-5@m uk-first-column " uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">
                            <div className="uk-panel uk-width-1-1">            

                                <div className="uk-panel uk-margin trip-heading-one uk-animation-slide-bottom-medium" style={{verticalAlign:"middle", lineHeight:"1.1"}}>

                               <div className='trip-ultra trip-heading-display copy-margin-bottom ' style={{letterSpacing:"-1.5px"}} uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
                               There’s now close to 400MM travelers who visit Tripadvisor every month.
                               </div> 
                                    
                                    
                                    <div className="uk-margin-top" uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
                                    So no matter where you are in the world, you’re never really <span onMouseEnter={showCard} onMouseLeave={hideCard} onClick={showCard} className="alone-button">alone.</span> 
                                    </div>

                                </div>

                            </div>

                        </div>

                         <div className="uk-width-3-5@m uk-flex uk-flex-middle" uk-height-viewport="offset-bottom: 35;">



                            <div className="uk-panel uk-width-1-1">            

                                <div className="uk-width-1-1 uk-flex uk-flex-right ">

                                    <div className='uk-card uk-card-border posts-container forum-review-container uk-animation-slide-bottom-medium' hidden={isHidden}>

                                    <div className='uk-badge uk-card-badge forum-badge'>
                                    <img src={replyIcon} alt="Facebook Icon" className='forum-badge-icon' />
                                </div>

                                <div className='uk-grid uk-grid-small'>

                                    <div className='uk-width-auto'>

                                        <div className='uk-text-center uk-margin-auto '>

                                            <div className='uk-text-center'>

                                                <img src={postsImageOne} alt="User Avatar" className='post-review-avatar uk-border-circle' />

                                            </div>

                                            <div className='forum-review-user uk-text-center'>
                                            @HeliosAlex
                                            </div>

                                        </div>

                                    </div>



                                    <div className='uk-width-2-3'>
                                        <div className='forum-review-content'>
                                            <div className='posts-review-title trip-ultra'>

                                            Place where no human<br/>has been before

                                            </div>
                                            <div className='posts-review-content'>
                                                Hi. I wonder if there is a place somewhere (Sahara, Greenland, Antarctica) 
                                                which noone has ever seen and I can somehow go there and be the first one.
                                            </div>

                                            {/* <div className='posts-button'>
                                                Reply
                                            </div> */}
                                        </div>

                                    </div>

                            </div>

                                    </div>
                               
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

        </div>


</div>

</div>

{/* Mobile View */}
<div className='uk-section uk-padding-remove trip-background-moss uk-hidden@s' >
        <div data-src={mapBackgroundSmall} uk-img={mapBackgroundSmall} className=" uk-background-norepeat uk-background-cover uk-background-top-left uk-section uk-flex" >    
        <div className="uk-width-1-1 uk-flex">


                <div className="uk-container uk-container-large uk-padding"> 

                <div ref={mapRef} className="rehere" >

                </div>

                    <div className="uk-grid-collapse uk-grid-margin uk-grid uk-grid-large" uk-grid="">


                        <div className="uk-grid-item-match uk-width-2-5@m uk-first-column " uk-scrollspy="target: [uk-scrollspy-class]; cls: uk-animation-slide-bottom-small; delay: 200; offset-top: 100; repeat: true;">
                            <div className="uk-panel uk-width-1-1">            

                                <div className="uk-panel uk-margin trip-heading-one uk-animation-slide-bottom-medium" style={{verticalAlign:"middle", lineHeight:"1.1"}}>

                               <div className='trip-ultra trip-heading-display copy-margin-bottom' style={{letterSpacing:"-1.5px"}} uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
                               There’s now close to 400MM travelers who visit Tripadvisor every month.
                               </div> 
                                    
                                    
                                    <div className="uk-margin-top" uk-scrollspy-class="uk-animation-slide-bottom-medium"> 
                                    So no matter where you are in the world, you’re never really <span onMouseEnter={showCard} onMouseLeave={hideCard} onClick={showCard} className="alone-button">alone.</span> 
                                    </div>

                                </div>

                            </div>

                        </div>

                         <div className="uk-width-3-5@m uk-flex uk-flex-middle" uk-height-viewport="offset-bottom: 35;">



                            <div className="uk-panel uk-width-1-1">            

                                <div className="uk-width-1-1 uk-flex uk-flex-right ">

                                    <div className='uk-card uk-card-border posts-container forum-review-container uk-animation-slide-bottom-medium' hidden={isHidden}>

                                    <div className='uk-badge uk-card-badge forum-badge'>
                                    <img src={replyIcon} alt="Facebook Icon" className='forum-badge-icon' />
                                </div>

                                <div className='uk-grid uk-grid-collapse'>

                                    <div className='uk-width-auto'>

                                        <div className='uk-text-center uk-margin-auto'>

                                        <div className='uk-text-center'>

                                            <img src={postsImageOne} alt="User Avatar" className='post-review-avatar uk-border-circle' />

                                        </div>

                                        <div className='forum-review-user uk-text-center'>
                                        @HeliosAlex
                                        </div>

                                        </div>

                                    </div>



                                    <div className='uk-width-2-3'>
                                        <div className='forum-review-content'>
                                            <div className='posts-review-title trip-ultra'>

                                            Place where no human<br/>has been before

                                            </div>
                                            <div className='posts-review-content'>
                                                Hi. I wonder if there is a place somewhere (Sahara, Greenland, Antarctica) 
                                                which noone has ever seen and I can somehow go there and be the first one.
                                            </div>

                                            {/* <div className='posts-button'>
                                                Reply
                                            </div> */}
                                        </div>

                                    </div>

                            </div>

                                    </div>
                               
                                </div>

                            </div>
                        </div>
                    </div>
                </div>

        </div>


</div>

</div>






</>
  )
}

export default MapSection